/**
 * The states a cell can show
 */
export const SettableCellStates = ["UNREACHED", "EXCEEDED", "HIGHLIGHTED"];
export const PayTableCellStates = [...SettableCellStates, "AVAILABLE_WIN"];
//# sourceMappingURL=PayTableCellStates.js.map